import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from 'services/alert.service';
import { NavigationService } from 'services/navigation.service';
import { UserService } from 'services/user.service';
import { UserSessionService } from 'services/usersession.service';

@Component({
  selector: 'app-resalepage',
  templateUrl: './resalepage.component.html',
  styleUrls: ['./resalepage.component.scss']
})
export class ResalepageComponent implements OnInit {

  salesform: FormGroup;
  id: 0;
  actionInfo: any;
  routeParams: any;
  submitbtn: string;
  formEditMode: boolean;
  data: any;
  isReadOnly: boolean;
  isDisable: boolean;

  constructor(private activateroute: ActivatedRoute, private route: ActivatedRoute
    , private userService: UserService, private formBuilder: FormBuilder
    , private navigationService: NavigationService) { }

  ngOnInit() {
    this.routeParams = this.activateroute.snapshot.params;
    this.id = this.routeParams.id;
    this.actionInfo = this.routeParams.actionInfo
    this.get(true);
    this.initializeValidators();
  }
  initializeValidators() {
    this.salesform = this.formBuilder.group({
      id: [this.id, Validators.required],
      resellerName: ['', [Validators.required]],
      resellerCode: ['', [Validators.required]],
    });
    if (this.id === 0) {
      this.submitbtn = 'Save';
    } else {
      this.submitbtn = 'Update';
    }
    if (this.actionInfo == 1) {
      this.formEditMode = false
    }
  }

  onSave() {
    this.userService.resellerdetail(this.salesform.value).subscribe(
      result => {
        this.navigationService.goToResellerGrid();
      }
    )
  }

  get(refresh: boolean) {
    if (this.id > 0) {
      this.userService.GetResellId(this.id, refresh).subscribe(result => {
        this.data = result;
        if (this.data) {
          this.salesform.patchValue(this.data);
          if (this.formEditMode === false) {
            this.isReadOnly = false;
            this.salesform.disable();
            this.isDisable = true;
          }
        }
      });
      this.isReadOnly = true;
    }
  }
  
  onClose() {
    this.navigationService.goToResellerGrid();
  }

}
